<template>
  <div class="row">
    <div class="col-12 px-3">
      <div class="table-responsive">
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th>{{ $t("nombre") }}</th>
              <th>{{ $t("apellidos") }}</th>
              <th class="d-none d-md-table-cell">{{ $t("dni") }}</th>
              <th>{{ $t("acciones") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(c, n) in copropietarios" :key="n">
              <td class="text-left pl-1">{{ c.name }}</td>
              <td class="text-left pl-1">{{ c.lastname }}</td>
              <td class="d-none d-md-table-cell">{{ c.dni }}</td>
              <!-- botones de accion -->
              <td class="px-0">
                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary btn-gr mx-1 mini-btn my-auto"
                  @click="editarCoprop(c)"
                >
                  <i aria-hidden="true" class="fa fa-edit"></i>
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-danger btn-gr mini-btn my-auto mx-0"
                  @click="deleteCoprop(n)"
                >
                  <i aria-hidden="true" class="fa fa-trash-o"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "dog-copropietario-list",
  props: ["lista"],
  data: () => ({}),
  methods: {
    /* enviar al parent editar coprop */
    editarCoprop(coprop) {
      console.log(coprop)
      this.$emit('emitEditCoprop', coprop);
    },
    /* enviar al parent eliminar coprop */
    deleteCoprop(idx) {
      this.$emit('emitDelCoprop', idx);
    }
  },
  computed: {
    copropietarios() {
      return this.lista;
    },
  },
};
</script>

<style scoped>
.mini-btn {
  height: 24px;
}
</style>
